// import moment from 'moment'
import {
    O365_LOAD_EVENTLIST_REQUEST,
    O365_LOAD_EVENTLIST_SUCCESS,

    O365_LOAD_EVENTDETAIL_REQUEST,
    O365_LOAD_EVENTDETAIL_SUCCESS,

    O365_LOAD_EVENTLIST_BETWEEN_REQUEST,
    O365_LOAD_EVENTLIST_BETWEEN_SUCCESS,

    CORE_LOAD_SETTING_INFO_REQUEST,
    CORE_LOAD_SETTING_INFO_SUCCESS,

    O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST,
    O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS,

    CORE_LOAD_EVENTHOME_REQUEST,
    CORE_LOAD_EVENTHOME_SUCCESS,

    CORE_LOAD_EVENT_TYPE_REQUEST,
    CORE_LOAD_EVENT_TYPE_SUCCESS,

    CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST,
    CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS,

    CORE_GET_CONFERENCE_TYPE_LIST_REQUEST,
    CORE_GET_CONFERENCE_TYPE_LIST_SUCCESS,

    CORE_LOAD_ATTENDEE_CHECKIN_REQUEST,
    CORE_LOAD_ATTENDEE_CHECKIN_SUCCESS,
} from '../../types'

const initialState = []
const requestState = 'request'
export default {
    eventList: (state = initialState, action) => {
        switch (action.type) {
            case O365_LOAD_EVENTLIST_REQUEST:
            case O365_LOAD_EVENTLIST_BETWEEN_REQUEST:
                return requestState
            case O365_LOAD_EVENTLIST_SUCCESS:
                let setEvents = []
                if (action && action.payload && Array.isArray(action.payload.value)) {
                    return action.payload.value
                }
                return setEvents
            case O365_LOAD_EVENTLIST_BETWEEN_SUCCESS:
                if (action.payload) {
                    return action.payload.value
                }
                return []
            default:
                return state
        }
    },
    eventDetail: (state = {}, action) => {
        switch (action.type) {
            case O365_LOAD_EVENTDETAIL_REQUEST:
                return {}
            case O365_LOAD_EVENTDETAIL_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    setting: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_SETTING_INFO_REQUEST:
                return state
            case CORE_LOAD_SETTING_INFO_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    eventHome: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENTHOME_REQUEST:
                return state
            case CORE_LOAD_EVENTHOME_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    eventFullCalendar: (state = {}, action) => {
        switch (action.type) {
            case O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST:
                return state
            case O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS:
                if (action.payload)
                    if (Array.isArray(action.payload.value)) {
                        let value = []
                        action.payload.value.forEach(element => {
                            value.push({
                                title: element.subject,
                                start: element.startDateTime,
                                end: element.endDateTime,
                                color: '#2185d0',
                                event: element
                            })
                        })
                        return value
                    }
                return []
            default:
                return state
        }
    },
    eventTypeList: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENT_TYPE_REQUEST:
                return state
            case CORE_LOAD_EVENT_TYPE_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    eventRoomFormat: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST:
                return state
            case CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    conferenceTyleList: (state = [], action) => {
        switch (action.type) {
            case CORE_GET_CONFERENCE_TYPE_LIST_REQUEST:
                return state
            case CORE_GET_CONFERENCE_TYPE_LIST_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    attendeeCheckinList: (state = [], action) => {
        switch (action.type) {
            case CORE_LOAD_ATTENDEE_CHECKIN_REQUEST:
                return state
            case CORE_LOAD_ATTENDEE_CHECKIN_SUCCESS:
                return action.payload
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/events/reducer.js